import { fetchApi } from './api';

export type DocType =
  | 'CSV_CLIENTS'
  | 'RECEIPT'
  | 'BANK_TRANSFER_SCREENSHOT'
  | 'BUSINESS_CARD'
  | 'INVOICE_TEMPLATE'
  | 'OTHER';

export interface PresignParams {
  fileName: string;
  fileType: string;
  fileSize: number;
  docType: DocType;
  linkedThreadId?: string;
}

export interface PresignResponse {
  uploadUrl: string;
  documentId: string;
  fileUrl: string;
  fileKey: string;
}

export async function presignUpload(params: PresignParams): Promise<PresignResponse> {
  return fetchApi<PresignResponse>('/upload/presign', {
    method: 'POST',
    body: JSON.stringify(params),
  });
}

export function uploadToR2(
  uploadUrl: string,
  file: File,
  onProgress?: (pct: number) => void,
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.upload.addEventListener('progress', (e) => {
      if (e.lengthComputable && onProgress) {
        onProgress(Math.round((e.loaded / e.total) * 100));
      }
    });
    xhr.addEventListener('load', () => {
      if (xhr.status >= 200 && xhr.status < 300) resolve();
      else reject(new Error(`Upload failed: HTTP ${xhr.status}`));
    });
    xhr.addEventListener('error', () => reject(new Error('Upload network error')));
    xhr.open('PUT', uploadUrl);
    xhr.setRequestHeader('Content-Type', file.type || 'application/octet-stream');
    xhr.send(file);
  });
}
